import {
  Exercise,
  Level,
  Phase,
  TextInterpolationVariable,
  ScheduleEntryColourCode,
  SessionSequence,
  UserExerciseSession,
  WorkoutSettings,
} from '../../entities';
import { ISessionSequenceStrategy } from './isessionsequencestrategy';

export class MachineTrain implements ISessionSequenceStrategy {
  public getSessionSequence(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
    level?: Level,
    workoutSettings?: WorkoutSettings,
    previousExerciseSessions?: UserExerciseSession[],
    exerciseFormatDescription?: string,
    loop?: number,
  ): SessionSequence[] {
    const minutesUntilWorkoutEnds: TextInterpolationVariable = 'minutesUntilWorkoutEnds';
    return [{
      durationInMilliseconds: 120,
      sequence: [{
        durationInMilliseconds: 120,
        videoFile: '',
        exerciseVersion: '',
        displayName: '',
        displayBurnOrBuildIcon: false,
        progressColourCode: ScheduleEntryColourCode.Play,
        progressText: `Remaining {${minutesUntilWorkoutEnds}}m`,
        showProcessedMetrics: false,
        showCalculatedMetrics: true,
        tips: Exercise.getFormattedTips(exercise),
        phase: Phase.Train,
        zone,
      }],
    }];
  }
}
